import Alert from './Alert';
import PopWrapper from '../utils/PopWrapper';

const PopAlert = PopWrapper(Alert);

export { PopAlert };
export { Alert };
